import { Spinner } from '@7shifts/sous-chef';
import { lazy, Suspense } from 'react';
import ErrorBoundary from 'sharedComponents/ErrorBoundary';
import KanbanRouteGuard from './pages/KanbanPage/KanbanRouteGuard';

const TicketsPage = lazy(() => import('./pages/TicketsPage'));
const KanbanPage = lazy(() => import('./pages/KanbanPage'));

export const ROUTES = [
    {
        path: '/tickets',
        element: (
            <Suspense fallback={<Spinner block />}>
                <TicketsPage key={'TicketsPage'} />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/kanban',
        element: (
            <Suspense fallback={<Spinner block />}>
                <KanbanRouteGuard>
                    <KanbanPage key={'KanbanPage'} />
                </KanbanRouteGuard>
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    }
];
